import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { db } from 'src/app/db/db';
import { ConsommableRepository } from 'src/app/db/repository/consommable.repository';
import { EndoscopeRepository } from 'src/app/db/repository/endoscope.repository';
import { FlaconRepository } from 'src/app/db/repository/flacon.repository';
import { InterventionRepository } from 'src/app/db/repository/intervention.repository';
import { PrelevementRepository } from 'src/app/db/repository/prelevement.repository';
import { Endoscope } from 'src/app/domain/Endoscope/endoscope';
import { EConditionPrelevement } from 'src/app/domain/Endoscope/enums/condition-prelevement';
import { EConditionStockage } from 'src/app/domain/Endoscope/enums/condition-stockage';
import { EConsommableEndoscope } from 'src/app/domain/Endoscope/enums/consommable-endoscope';
import { EMarque } from 'src/app/domain/Endoscope/enums/marque';
import { EMotifPrelevement } from 'src/app/domain/Endoscope/enums/motif-prelevement';
import { EPortee } from 'src/app/domain/Endoscope/enums/portee';
import { ETraitement } from 'src/app/domain/Endoscope/enums/traitement';
import { EType } from 'src/app/domain/Endoscope/enums/type';
import { ETypeEauRincage } from 'src/app/domain/Endoscope/enums/type-eau-rincage';
import { Consommable } from 'src/app/domain/consommable';
import { EFlaskType } from 'src/app/domain/enums/flask-type';
import { EInterventionStatus } from 'src/app/domain/enums/intervention-status';
import { EServiceType } from 'src/app/domain/enums/service-type';
import { Flacon } from 'src/app/domain/flacon';
import { Intervention } from 'src/app/domain/intervention';
import { Prelevement } from 'src/app/domain/prelevement';
import { ETaskStatus } from 'src/app/models/enums/task-status';
import { SimpleListModel } from 'src/app/models/simple-list-model';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { PreventDoubleClickDirective } from 'src/app/tools/directive/prevent-double-click.directive';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConsommableBoxDialog } from 'src/app/tools/ui/consommable-box/consommable-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-endoscope',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatSlideToggleModule, NgxMaterialTimepickerModule, MatDatepickerModule, MatButtonModule, MatIconModule, FormsModule, MatSelectModule, MatOptionModule, PreventDoubleClickDirective],
    templateUrl: './endoscope.component.html',
    styleUrl: './endoscope.component.scss'
})
export class EndoscopeComponent {

    EInterventionStatus = EInterventionStatus;
    EServiceType = EServiceType;
    EConditionStockage = EConditionStockage;

    public TypeEndoscopeList: SimpleListModel[] = Object.values(EType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => {
            // const slm = new SimpleListModel({idx: x, s: StringConverter.getEndoscopeTypelabel(x)});
            // slm.idx = x as number;
            // slm.s = StringConverter.getEndoscopeTypelabel(x)
            // return slm;
            return new SimpleListModel({idx: x, s: StringConverter.getEndoscopeTypelabel(x)});
        });

    public MotifList: SimpleListModel[] = Object.values(EMotifPrelevement)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => {
            // const slm = new SimpleListModel();
            // slm.idx = x as number;
            // slm.s = StringConverter.getMotifPrelevementlabel(x)
            // return slm;
                        return new SimpleListModel({idx: x, s: StringConverter.getMotifPrelevementlabel(x)});
        });

    public ConditionStockageList: SimpleListModel[] = Object.values(EConditionStockage)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => {
            // const slm = new SimpleListModel();
            // slm.idx = x as number;
            // slm.s = StringConverter.getConditionStockagelabel(x)
            // return slm;
            return new SimpleListModel({idx: x, s: StringConverter.getConditionStockagelabel(x)});
        });
    // MotifPrelevementList: string[] = Object.values(EMotifPrelevement)
    //     .filter(x => !isNaN(Number(x)))
    //     .map((x: any) => StringConverter.getMotifPrelevementlabel(x));

    TraitementList: string[] = Object.values(ETraitement)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getTraitementlabel(x));
    // CycleTraitementList: string[] = Object.values(ECycleTraitement)
    //     .filter(x => !isNaN(Number(x)))
    //     .map((x: any) => StringConverter.getCycleTraitementlabel(x));
    TypeEauRincageList: string[] = Object.values(ETypeEauRincage)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getTypeEauRincagelabel(x));

    ConditionPrelevementList: string[] = Object.values(EConditionPrelevement)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getConditionPrelevementlabel(x));

    // ConditionStockageList: string[] = Object.values(EConditionStockage)
    //     .filter(x => !isNaN(Number(x)))
    //     .map((x: any) => StringConverter.getConditionStockagelabel(x));

    PorteeList: string[] = Object.values(EPortee)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getPorteeLabel(x));

    MarqueList: string[] = Object.values(EMarque)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMarqueEndoscopelabel(x));

    Endoscope?: Endoscope;

    DateDerniereLavage?: Date;
    DefaultTime!: string;
    TimeSampling!: string
    _SamplingDate!: Date
    TimeBionettoyage!: string
    _BionettoyageDate!: Date

    // Stockage
    DateStockage?: Date;
    TimeStockage!: string
    _StockageDate!: Date

    endoCode: string = '';
    scannedCode: string = '';
    filteredEndoscopeOptions: SimpleListModel[] = []
    SearchEndoscopeText: string = '';

    filteredMotifOptions: SimpleListModel[] = []
    SearchMotifText: string = '';

    filteredConditionStockageOptions: SimpleListModel[] = []
    SearchConditionStockageText: string = '';

    Intervention: Intervention | undefined;

    constructor(
        private location: Location,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private coreData: CoreData,
        private route: ActivatedRoute,

        private prelevementRepository: PrelevementRepository,
        private endoscopeRepository: EndoscopeRepository,
        private consommableRepository: ConsommableRepository,
        private flaconRepository: FlaconRepository,
        private interventionRepository: InterventionRepository,
    ) {
        this.DefaultTime = `${Temporal.Now.plainDateTimeISO().hour}:${Temporal.Now.plainDateTimeISO().minute}`
    }

    async ngAfterContentInit(): Promise<void> {
        this.endoCode = this.route.snapshot.params['endoCode'];
        this.scannedCode = this.route.snapshot.params['result'];

        this.Intervention = await this.interventionRepository.getInterventionByEndoscopeCode(this.endoCode)

        this.Endoscope = await this.endoscopeRepository.getEndoscopeByCodeWithChildren(this.endoCode);
        this.coreData.CurrentPageName = this.Endoscope.ZoneSalle;

        if (this.Endoscope.SamplingDate) {
            this.TimeSampling = `${this.Endoscope.SamplingDate.hour}:${this.Endoscope.SamplingDate.minute}`;
        }

        if (this.Endoscope.DateDernierLavage)
            this.DateDerniereLavage = new Date(this.Endoscope.DateDernierLavage.year, this.Endoscope.DateDernierLavage.month - 1, this.Endoscope.DateDernierLavage.day)
        if (this.Endoscope.DateDernierLavage) {
            this.TimeBionettoyage = `${this.Endoscope.DateDernierLavage.hour}:${this.Endoscope.DateDernierLavage.minute}`;
        }

        if (this.Endoscope.DateStockageESET)
            this.DateStockage = new Date(this.Endoscope.DateStockageESET.year, this.Endoscope.DateStockageESET.month - 1, this.Endoscope.DateStockageESET.day)
        if (this.Endoscope.DateStockageESET) {
            this.TimeStockage = `${this.Endoscope.DateStockageESET.hour}:${this.Endoscope.DateStockageESET.minute}`;
        }

        this.filteredEndoscopeOptions = this.TypeEndoscopeList
        this.SearchEndoscopeText = this.TypeEndoscopeList.find(x => x.idx === this.Endoscope?.TypeEndoscope)!.s

        this.filteredMotifOptions = this.MotifList
        this.SearchMotifText = this.MotifList.find(x => x.idx === this.Endoscope?.MotifPrelevement)?.s ?? ''

        this.filteredConditionStockageOptions = this.ConditionStockageList
        this.SearchConditionStockageText = this.ConditionStockageList.find(x => x.idx === this.Endoscope?.ConditionStockage)?.s ?? ''
    }

    filterEndoscopeList() {
        this.filteredEndoscopeOptions = this.TypeEndoscopeList.filter(x => x.idx && x.s.toLowerCase().startsWith(this.SearchEndoscopeText.toLowerCase()))

    }
    onSelectionChange(event: MatAutocompleteSelectedEvent) {

        if (!this.Endoscope)
            return;
        this.Endoscope.TypeEndoscope = event.option.value.idx;
        this.SearchEndoscopeText = this.TypeEndoscopeList.find(x => x.idx === this.Endoscope?.TypeEndoscope)!.s
    }

    filterMotifList() {
        this.filteredMotifOptions = this.MotifList.filter(x => x.idx && x.s.toLowerCase().startsWith(this.SearchMotifText.toLowerCase()))

    }
    onMotifSelectionChange(event: MatAutocompleteSelectedEvent) {

        if (!this.Endoscope)
            return;
        this.Endoscope.MotifPrelevement = event.option.value.idx;
        this.SearchMotifText = this.MotifList.find(x => x.idx === this.Endoscope?.MotifPrelevement)!.s
    }

    filterConditionStockageList() {
        this.filteredConditionStockageOptions = this.ConditionStockageList.filter(x => x.idx && x.s.toLowerCase().startsWith(this.SearchConditionStockageText.toLowerCase()))

    }
    onConditionStockageSelectionChange(event: MatAutocompleteSelectedEvent) {

        if (!this.Endoscope)
            return;
        this.Endoscope.ConditionStockage = event.option.value.idx;
        this.SearchConditionStockageText = this.ConditionStockageList.find(x => x.idx === this.Endoscope?.ConditionStockage)!.s
    }

    dateDernierLavageChanged(event: MatDatepickerInputEvent<Date>) {
        // if (this.Zone?.DateDernierLavage) {
        //     return;
        // }
        this.DateDerniereLavage ??= new Date();
        this.Endoscope!.DateDernierLavage = Temporal.PlainDateTime.from({
            year: this.DateDerniereLavage.getFullYear(),
            day: this.DateDerniereLavage.getDate(),
            month: this.DateDerniereLavage.getMonth() + 1,
            hour: this.Endoscope!.DateDernierLavage ? this.Endoscope!.DateDernierLavage.hour : this.DateDerniereLavage.getHours(),
            minute: this.Endoscope!.DateDernierLavage ? this.Endoscope!.DateDernierLavage.minute : this.DateDerniereLavage.getMinutes()
        });
    }
    clearBionettoyage() {
        this.TimeBionettoyage = '';
        this.Endoscope!.DateDernierLavage = undefined;
    }

    timeSetBionettoyage(event: string) {
        if (!this.Endoscope)
            return;
        const time = event.split(':');
        // this.Zone.DateDernierLavage = Temporal.Now.plainDateTimeISO();
        this._BionettoyageDate = new Date();
        this._BionettoyageDate.setHours(Number(time[0]), Number(time[1]));
        this.Endoscope.DateDernierLavage = Temporal.PlainDateTime.from({
            year: this.Endoscope.DateDernierLavage?.year ? this.Endoscope.DateDernierLavage.year : this._BionettoyageDate.getFullYear(),
            day: this.Endoscope.DateDernierLavage?.day ? this.Endoscope.DateDernierLavage.day : this._BionettoyageDate.getDate(),
            month: this.Endoscope.DateDernierLavage?.month ? this.Endoscope.DateDernierLavage.month : this._BionettoyageDate.getMonth() + 1,
            hour: this._BionettoyageDate.getHours(),
            minute: this._BionettoyageDate.getMinutes()
        });
        this.setTimeBionettoyage();
    }

    setTimeBionettoyage() {
        this.TimeBionettoyage = `${this._BionettoyageDate.getHours()}:${this._BionettoyageDate.getMinutes()}`;
    }

    // #region stockage
    dateStockageChanged(event: MatDatepickerInputEvent<Date>) {
        // if (this.Zone?.DateDernierLavage) {
        //     return;
        // }
        this.DateStockage ??= new Date();
        this.Endoscope!.DateStockageESET = Temporal.PlainDateTime.from({
            year: this.DateStockage.getFullYear(),
            day: this.DateStockage.getDate(),
            month: this.DateStockage.getMonth() + 1,
            hour: this.Endoscope!.DateStockageESET ? this.Endoscope!.DateStockageESET.hour : this.DateStockage.getHours(),
            minute: this.Endoscope!.DateStockageESET ? this.Endoscope!.DateStockageESET.minute : this.DateStockage.getMinutes()
        });
    }
    clearStockage() {
        this.TimeStockage = '';
        this.Endoscope!.DateStockageESET = undefined;
    }

    timeStockage(event: string) {
        if (!this.Endoscope)
            return;
        const time = event.split(':');
        // this.Zone.DateDernierLavage = Temporal.Now.plainDateTimeISO();
        this._StockageDate = new Date();
        this._StockageDate.setHours(Number(time[0]), Number(time[1]));
        this.Endoscope.DateStockageESET = Temporal.PlainDateTime.from({
            year: this.Endoscope.DateStockageESET?.year ? this.Endoscope.DateStockageESET.year : this._StockageDate.getFullYear(),
            day: this.Endoscope.DateStockageESET?.day ? this.Endoscope.DateStockageESET.day : this._StockageDate.getDate(),
            month: this.Endoscope.DateStockageESET?.month ? this.Endoscope.DateStockageESET.month : this._StockageDate.getMonth() + 1,
            hour: this._StockageDate.getHours(),
            minute: this._StockageDate.getMinutes()
        });
        this.setTimeStockage();
    }

    setTimeStockage() {
        this.TimeStockage = `${this._StockageDate.getHours()}:${this._StockageDate.getMinutes()}`;
    }
    // #endregion

    getFlaskTypeLabel(type: EFlaskType) {
        return StringConverter.getFlaskTypeLabel(type);
    }

    getConsommableEndoscopeLabel(type: EConsommableEndoscope) {
        return StringConverter.getConsommableEndoscopeLabel(type);
    }

    getUniquePSV() {
        if (!this.Endoscope)
            return;

        return _.uniqBy([
            ...this.Endoscope.CanalEndoscopeList.map(x => x.Prelevement.SamplingPoint)
        ], x => x.Name);
    }

    clearSampling() {
        this.TimeSampling = '';
        this.Endoscope!.SamplingDate = undefined;
    }

    timeSetSampling(event: string) {
        if (!this.Endoscope)
            return;
        const time = event.split(':');
        this.Endoscope.SamplingDate = Temporal.Now.plainDateTimeISO();
        this._SamplingDate = new Date();
        this._SamplingDate.setHours(Number(time[0]), Number(time[1]));
        this.Endoscope.SamplingDate = Temporal.PlainDateTime.from({ year: this._SamplingDate.getFullYear(), day: this._SamplingDate.getDate(), month: this._SamplingDate.getMonth() + 1, hour: this._SamplingDate.getHours(), minute: this._SamplingDate.getMinutes() });
        this.setTimeDepartDomicile();
    }

    setTimeDepartDomicile() {
        this.TimeSampling = `${this._SamplingDate.getHours()}:${this._SamplingDate.getMinutes()}`;
    }

    canBeDisabled(flacon: Flacon) {

        return flacon.Barcode !== null && flacon.Barcode !== '' && flacon.Barcode.length >= 13
            && !this.Endoscope?.CanalEndoscopeList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode)
            ;
    }

    checkBarCode(event: KeyboardEvent, barCode: string) {
        if (!barCode)
            return;
        if (barCode.length >= 14) {
            event.preventDefault()
        }
    }

    public focusNext(barcode: string, j: number, i: number, type: EServiceType, size: number) {
        if (barcode.length < 13) {
            return
        }

        let nextElementSiblingId;
        if (i < size - 1)
            nextElementSiblingId = `barcode${type}-${j}-${i + 1}`;
        else
            nextElementSiblingId = `barcode${type}-${j + 1}-${i}`;

        (document.querySelector(`#${nextElementSiblingId}`)! as any).focus()
    }

    async checkBarCodeExistence(code: string) {

        let flacon = this.Endoscope?.CanalEndoscopeList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code === code)
        if (flacon && StringTool.isNotNullOrEmpty(flacon.Barcode)
            && (this.Endoscope?.CanalEndoscopeList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode)
                || await this.flaconRepository.checkIfBarcodeExists(flacon.Barcode))) {
            NotificationManager.handleError('Barcode déjà scanné !', this.snackBar)
            flacon.Barcode = '';
        }
    }

    async deleteConsommable(cons: Consommable, prel: Prelevement) {
        let sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithEndoscopeOnly();
        let prelevementList;

        this.Endoscope!.CanalEndoscopeList.forEach(x => _.remove(x.Prelevement.ConsommableList, y => y.NumeroLot === cons.NumeroLot))
        prelevementList = sameTypeOfServiceIntervenList.map(x => x.EndoscopeList.map(y => y.CanalEndoscopeList.map(z => z.Prelevement))).flat(2)

        prelevementList?.forEach(async x => {
            x.ConsommableList.forEach(async y => {
                await this.consommableRepository.deleteConsommableByNumeroLot((await this.prelevementRepository.getPrelevementEntityByCode(prel.Code))!)
            })
        })
    }

    openConsommableBox(typeOfService: EServiceType, prel: Prelevement, cons?: Consommable) {
        const dialogRef = this.dialog.open(ConsommableBoxDialog, {
            data: {
                typeOfService,
                consommable: cons
            },
            width: '777px',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe(async (result: Consommable) => {
            if (result) {
                // await db.updateLastUsedConsommableByType(result, typeOfService)
                // result.Id = await this.consommableRepository.attachConsommable(result, (await this.prelevementRepository.getPrelevementEntityByCode(prel.Code))!);
                // prel.ConsommableList.push(result)
                switch (typeOfService) {
                    case EServiceType.Endoscope:
                        this.Endoscope!.CanalEndoscopeList.forEach(x => x.Prelevement.ConsommableList.push(result))
                        break;
                }
                NotificationManager.handleSuccess('Consommable ajouté', this.snackBar);
            }
        });
    }

    async showAlert(withFinishedFlag: boolean) {

        let missingBarCodes = [
            ...this.Endoscope?.CanalEndoscopeList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!
        ]

        if (missingBarCodes.length === 0 ) {
            await this.save(withFinishedFlag)
            return;
        }
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: {
                message: `Enregistrer avec ces informations manquantes ?
                        ${missingBarCodes.length > 0 ? `Code à barres:\n ${missingBarCodes.join('\n')}` : ''} `,
                withCancelButton: true
            },
            height: '80%',
        });
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {
                await this.save(withFinishedFlag)
                return;
            }
        })
    }

    canSave() {
        // let missingBarCodes = [
        //     ...this.Endoscope?.CanalEndoscopeList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!
        // ]
        let alreadyScannedBarCodes = [
            ...this.Endoscope?.CanalEndoscopeList.filter(x => x.Prelevement.FlaconList.some(y => StringTool.isNotNullOrEmpty(y.Barcode)))!,
            
        ]

        let missingSamplingDate = this.Endoscope?.SamplingDate ? false : true

        if ( alreadyScannedBarCodes.length === 0 || (alreadyScannedBarCodes.length > 0 && !missingSamplingDate))
            return true;

        if (alreadyScannedBarCodes.length > 0 && missingSamplingDate) {
            NotificationManager.handleWarning('Heure de prélèvement obligatoire', this.snackBar)
        }
        return false;
    }

    async save(withFinishedFlag: boolean, quiet?: boolean) {
        if (!this.canSave())
            return;
        // if (!this.checkIfThereAreAtLeastOneConsommableWhereThereIsABarCode()) {
        //     NotificationManager.handleSuccess('Vous devez remplir au moins 1 consommable par prélèvement', this.snackBar);
        //     return;
        // }
        if (withFinishedFlag)
            this.Endoscope!.TaskStatus = ETaskStatus.Done;

        const success = await this.endoscopeRepository.updateEndoscope(this.Endoscope!);

        if (success && !quiet) {
            NotificationManager.handleSuccess('Données enregistrées', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
